import { getClient } from '@/lib/restClient';
import { IntegrationReadyDeliveryStoreService } from '@/services/StoreManagement/IntegrationReadyDeliveryStore/IntegrationReadyDeliveryStoreService';

export type UpdateIntegrationReadyDeliveryStoreOrderManagerParams = {
  external_store_id: string;
  delivery_service_id: number;
  is_order_manager: boolean;
};

// 連携済（IntegrationStatusActivate）の Uber Eats 店舗 1 件に対して
// is_order_manager を即時切替する。複数店舗を一括で切替えたい場合は呼び出し側で逐次実行する。
export const useUpdateIntegrationReadyDeliveryStoreOrderManager = async (
  params: UpdateIntegrationReadyDeliveryStoreOrderManagerParams
): Promise<void> => {
  const integrationReadyDeliveryStoreService =
    new IntegrationReadyDeliveryStoreService(getClient());
  return await integrationReadyDeliveryStoreService.updateOrderManager(params);
};
